module.exports = __webpack_public_path__ + "static/media/circle.b0e2b8d9.png";